import { useSetAtom, useAtom, atom } from 'jotai';

// A notification asked to open Account settings → Subscriptions → Cards for
// this scope (`personal`, or an organization id); `null` when nothing waits.
const accountCardsRequestAtom = atom<null | string>(null);

// Write-only, for the notification click handler (toast + notification
// center) — same shape as useSetMembershipCardSetup. The toast lives under
// SnackbarProvider, so it must not pull the router/auth graph in itself.
export const useSetAccountCardsRequest = () => {
  const setScope = useSetAtom(accountCardsRequestAtom);
  return (scope: string) => setScope(scope);
};

// Read + clear, for the AppLayout host that navigates.
export const useAccountCardsRequestStore = () => {
  const [scope, setScope] = useAtom(accountCardsRequestAtom);
  return { clear: () => setScope(null), scope };
};
